import { GridItem } from "commons/ui/Grid";

import FiltersContainer from "components/ui/FiltersContainer";
import SearchInput from "components/ui/SearchInput";

import { SpecialOffersListHook } from "hooks/list/useSpecialOffersList";

function SpecialOffersTableFilters({
    specialOffersListHook,
}: {
    specialOffersListHook: SpecialOffersListHook;
}) {
    const { onSearchFilterChange, filterSearchHook } = specialOffersListHook;

    const { applyFilters, clearFilters, form } = filterSearchHook;

    return (
        <FiltersContainer applyFilters={applyFilters} clearFilters={clearFilters}>
            <GridItem className={"col-xs-12-4"}>
                <SearchInput
                    placeholder={"Cerca"}
                    value={form.search.title}
                    onChange={onSearchFilterChange}
                    filterInput
                />
            </GridItem>
        </FiltersContainer>
    );
}

export default SpecialOffersTableFilters;
